import React from "react";
import { Card } from "../../ui/Card";
import PropTypes from "prop-types";

const CardsCustomers = ({ data, loading = false }) => {
  const CARDS_DATA = [
    {
      title: "SMS",
      icon: "sms",
      text: "text-gray-600",
      value: Number(data?.i_sms),
    },
    {
      title: "RCS",
      icon: "mms",
      text: "text-cyan-600",
      value: Number(data?.i_rcs),
    },
    {
      title: "Total",
      icon: "attach_money",
      text: "text-green-600",
      value: Number(data?.n_amount),
      isCurrency: true,
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 lg:auto-cols-auto xl:auto-cols-auto gap-4">
      {CARDS_DATA.map((card, index) => (
        <Card
          key={index}
          title={card.title}
          icon={card.icon}
          text={card.text}
          loading={loading}
          value={card.value}
          isCurrency={card.isCurrency}
        />
      ))}
    </div>
  );
};

CardsCustomers.propTypes = {
  data: PropTypes.object,
  loading: PropTypes.bool,
};

export default CardsCustomers;
